import { render } from "./userBulk.vue?vue&type=template&id=2547462d&scoped=true"
import script from "./userBulk.vue?vue&type=script&lang=js"
export * from "./userBulk.vue?vue&type=script&lang=js"

import "./userBulk.vue?vue&type=style&index=0&id=2547462d&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2547462d"]])

export default __exports__